import { gql } from '@/__generated__';

export const CREATE_ALERT_CONFIGURATION = gql(`#graphql
  mutation CreateAlertConfiguration($configurationInput: CreateAlertConfigurationInput!) {
    createAlertConfiguration(input: $configurationInput) {
      id
    }
  }
`);